export default "__VITE_ASSET__BAxgSE$F__"